import { Link } from '@tanstack/react-router';
import { Button } from '../components/ui.tsx';

export function NotFound() {
  return (
    <div style={{ minHeight: '70dvh', display: 'grid', placeItems: 'center', position: 'relative', isolation: 'isolate', padding: 24 }}>
      <div className="grid-field" style={{ maskImage: 'radial-gradient(ellipse 50% 50% at 50% 50%, #000, transparent)' }} />
      <div className="stack" style={{ justifyItems: 'center', textAlign: 'center' }}>
        <span className="eyebrow">404</span>
        <h1 className="display" style={{ fontSize: 'var(--step-5)' }}>
          Nothing <em>here.</em>
        </h1>
        <p className="muted">The page may have moved when we rebuilt Hearth.</p>
        <Link to="/">
          <Button variant="primary" iconRight="arrowRight">
            Back to today
          </Button>
        </Link>
      </div>
    </div>
  );
}
